export default __webpack_public_path__ + "static/media/coral-left-type-1.18e749ce.gif";